import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import Pricing from "@/pages/Pricing";
import MyReports from "@/pages/MyReports";
import Settings from "@/pages/Settings";
import SuccessKit from "@/pages/SuccessKit";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancelled from "@/pages/PaymentCancelled";

function Protected({ children, layout = true }) {
  return <ProtectedRoute>{layout ? <AppLayout>{children}</AppLayout> : children}</ProtectedRoute>;
}

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback synchronously (URL fragment) before any routing.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/assessment" element={<Protected layout={false}><Assessment /></Protected>} />
      <Route path="/results/:reportId" element={<Protected><Results /></Protected>} />
      <Route path="/reports" element={<Protected><MyReports /></Protected>} />
      <Route path="/success-kit" element={<Protected><SuccessKit /></Protected>} />
      <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
      <Route path="/payment-success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment-cancelled" element={<Protected><PaymentCancelled /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
